import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const preAnaestheticApi = {
  getEval: async (uhid) => {
    const response = await api.get(`/get_pre_anaesthetic/${uhid}`);
    return response.data;
  },

  getPatient: async (uhid) => {
    const response = await api.get(`/get_patient/${uhid}`);
    return response.data;
  },

  getNextIp: async () => {
    const response = await api.get('/pre_anaesthetic_next_ip');
    return response.data;
  },

  createEval: async (data) => {
    const response = await api.post('/submit_pre_anaesthetic', data);
    return response.data;
  },

  updateEval: async (uhid, data) => {
    const response = await api.put(`/update_pre_anaesthetic/${uhid}`, data);
    return response.data;
  },

  generateShareToken: async (uhid) => {
    const response = await api.post(`/generate_for_pre_anaesthetic_api_share_token/${uhid}`);
    return response.data;
  }
};
